<span [title]="planStatuses[data[fieldName]]">{{planStatuses[data[fieldName]]}}</span>
